import { stopPropagation } from '../../../../utils/events'
import Button from '../../../Button'
import { TableCellBase } from '../TableCellBase'

import * as styles from './TableCellButton.module.css'

function TableCellButton({
  CellButton = Button.Text,
  buttonProps,
  id,
  onClick,
  ...cellProps
}) {
  function handleClick(event) {
    stopPropagation(event)
    onClick(id)
  }

  return (
    <TableCellBase {...cellProps}>
      <CellButton
        {...buttonProps}
        className={styles.TableCellButton}
        onClick={handleClick}
      />
    </TableCellBase>
  )
}

export default TableCellButton
